import React, { useState } from 'react'

import { Button } from 'semantic-ui-react'
import { AllowPermission } from 'shared/components/AllowPermission'
import { DescriptionPopup } from 'components/DescriptionPopup'
import UpgradePlanModalContainer from 'components/UpgradePlanModal/container'
import constants from 'config/constants'

/**
 * @typedef {Object} BaseProps
 * @property {string=} className
 * @property {string} [label]
 * @property {string | React.ReactElement} descriptionTitle
 * @property {React.ReactElement | null} [icon]
 * @property {string} learnMoreLink
 * @property {boolean} [showGotoBillingPage]
 */

/**
 * @typedef {BaseProps & {descriptionContent: string | React.ReactElement, descriptionContentWithFormat?: never}} PropsWithContent
 */

/**
 * @typedef {BaseProps & {descriptionContent?: never, descriptionContentWithFormat: React.ReactElement}} PropsWithFormattedContent
 */

/**
 * @typedef {PropsWithContent | PropsWithFormattedContent} TooltipLabelProps
 */

/**
 * @param {TooltipLabelProps} props
 */
export function TooltipLabel({
  className,
  label,
  icon,
  descriptionTitle,
  descriptionContent,
  descriptionContentWithFormat,
  learnMoreLink,
  showGotoBillingPage = false,
  position,
}) {
  const [isPopupOpen, setIsPopupOpen] = useState(false)
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false)

  const style = showGotoBillingPage ? { minWidth: 380 } : {}

  function openUpgradeModal() {
    setIsPopupOpen(false)
    setIsUpgradeModalOpen(true)
  }

  if (descriptionTitle || descriptionContent || descriptionContentWithFormat) {
    return (
      <label className={className}>
        {label}
        <DescriptionPopup
          className="grey ml2"
          style={style}
          open={isPopupOpen}
          onOpen={() => setIsPopupOpen(true)}
          onClose={() => setIsPopupOpen(false)}
          position={position}
        >
          {descriptionTitle && (
            <h3 className="ui dividing header" style={{ paddingBottom: '10px', paddingTop: '4px' }}>
              {descriptionTitle} {icon}
            </h3>
          )}
          {descriptionContent && <p>{descriptionContent}</p>}
          {descriptionContentWithFormat}
          {learnMoreLink && (
            <a
              className={`ui primary button ${showGotoBillingPage && 'mr3'}`}
              href={learnMoreLink}
              target="_blank"
              rel="noreferrer"
              onClick={preventEventPropagation}
            >
              <i className="book far icon" />
              Learn more
            </a>
          )}
          {showGotoBillingPage && (
            <AllowPermission permission={constants.permissions.manageBillingInformation}>
              <Button onClick={openUpgradeModal}>Upgrade plan</Button>
            </AllowPermission>
          )}
        </DescriptionPopup>
        <UpgradePlanModalContainer
          isOpen={isUpgradeModalOpen}
          onClose={() => setIsUpgradeModalOpen(false)}
        />
      </label>
    )
  }

  return <label className={className}>{label}</label>
}

function preventEventPropagation(e) {
  e.stopPropagation()
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/TooltipLabel/index.js